import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiArrivedPackageGet,
  apiArrivedPackagesListGet,
  apiArrivedParcelGet,
  apiArrivedParcelsListGet,
} from '@/entities/warehouse-arrivals/modules/api/warehouseArrivals';
import type {
  ApiArrivedPackagesListParams,
  ApiArrivedParcelsListParams,
} from '@/shared/types/api/warehouse-arrivals';

export const useArrivedPackagesList = (params: ApiArrivedPackagesListParams) =>
  useFetch({
    api: () => apiArrivedPackagesListGet(params),
    keywords: queryKeys.warehouseArrivals.packagesList(params),
    staleTime: 60_000,
  });

export const useArrivedPackageDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiArrivedPackageGet(id ?? ''),
    keywords: queryKeys.warehouseArrivals.packageDetail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });

export const useArrivedParcelsList = (params: ApiArrivedParcelsListParams) =>
  useFetch({
    api: () => apiArrivedParcelsListGet(params),
    keywords: queryKeys.warehouseArrivals.parcelsList(params),
    staleTime: 60_000,
  });

export const useArrivedParcelDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiArrivedParcelGet(id ?? ''),
    keywords: queryKeys.warehouseArrivals.parcelDetail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
